import { IModelBaseModel } from '../model-base/model-base.interface'
import { ModelBaseModel } from '../model-base/model-base.model'
import { TEventRegisteredUsers } from './event-registered-users.interface'

export class EventRegisteredUsersModel
  extends ModelBaseModel<TEventRegisteredUsers>
  implements IModelBaseModel
{
  public v: TEventRegisteredUsers['v']
  public id: TEventRegisteredUsers['id']
  public owner: TEventRegisteredUsers['owner']
  public userId: TEventRegisteredUsers['userId']
  public userEmail: TEventRegisteredUsers['userEmail']
  public eventId: TEventRegisteredUsers['eventId']
  public eventLat: TEventRegisteredUsers['eventLat']
  public userType: TEventRegisteredUsers['userType']
  public category: TEventRegisteredUsers['category']
  public userName: TEventRegisteredUsers['userName']
  public eventName: TEventRegisteredUsers['eventName']
  public eventLogo: TEventRegisteredUsers['eventLogo']
  public discipline: TEventRegisteredUsers['discipline']
  public eventState: TEventRegisteredUsers['eventState']
  public isRegistered: TEventRegisteredUsers['isRegistered']
  public registrationDate: TEventRegisteredUsers['registrationDate']
  public userProfilePicture: TEventRegisteredUsers['userProfilePicture']
  public answers: TEventRegisteredUsers['answers']
  public horsesIds: TEventRegisteredUsers['horsesIds']
  public membersIds: TEventRegisteredUsers['membersIds']

  public isSplit: TEventRegisteredUsers['isSplit']
  public cartItems: TEventRegisteredUsers['cartItems']

  public created: TEventRegisteredUsers['created']
  public modified: TEventRegisteredUsers['modified']

  public constructor(obj?: TEventRegisteredUsers) {
    super()
    this.v = obj?.v ?? 1
    this.id = obj?.id ?? null
    this.owner = obj?.owner ?? null
    this.userId = obj?.userId ?? null
    this.userEmail = obj?.userEmail ?? null
    this.eventId = obj?.eventId ?? null
    this.eventLat = obj?.eventLat ?? null
    this.category = obj?.category ?? null
    this.userType = obj?.userType ?? null
    this.userName = obj?.userName ?? null
    this.eventName = obj?.eventName ?? null
    this.eventLogo = obj?.eventLogo ?? null
    this.discipline = obj?.discipline ?? []
    this.horsesIds = obj?.horsesIds ?? []
    this.membersIds = obj?.membersIds ?? []
    this.isSplit = obj?.isSplit ?? false
    this.cartItems = obj?.cartItems ?? null
    this.answers = obj?.answers ?? []
    this.eventState = obj?.eventState ?? null
    this.isRegistered = obj?.isRegistered ?? false
    this.userProfilePicture = obj?.userProfilePicture ?? null

    this.registrationDate = obj?.registrationDate
      ? this.utcTimestamp({
          key: 'registrationDate',
          value: obj?.registrationDate,
        })
      : null

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified,
    })
  }

  static fromFirestoreDoc(doc: any, registeredUsers?: number) {
    return new EventRegisteredUsersModel({
      id: doc.id,
      registeredUsers,
      ...doc.data(),
    })
  }
}
